import { useAppStore } from "@/store/app/slice";
import { UserRole } from "@/types/users";
import { useFetchClientProfile } from "@/pages/Onboarding/Client/hooks/useFetchClientProfile";
import AddressDetails from "./AddressDetails";
import { SectionSkeleton } from "@/components/profile-cards";

const ClientDetailsSections = () => {
  const { profile } = useFetchClientProfile();

  if (!profile) {
    return <SectionSkeleton />;
  }

  return <AddressDetails profile={profile} />;
};

const ClientDetails = () => {
  const user = useAppStore((s) => s.user);

  if (user?.role === UserRole.Client) return <ClientDetailsSections />;

  return null;
};

export default ClientDetails;
